import {
  Autocomplete,
  Box,
  CircularProgress,
  FormLabel,
  TextField,
} from "@mui/material";
import useFormStyles from "../../styles/useFormStyles";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { constant } from "../../constants";
import theme from "../../theme";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "../../util/debounce";

export interface BasicAutoCompletePropTypes {
  options: string[];
  setState: Function;
  stateKey: string;
  secondaryStateKey: string;
  clear?: boolean;
  label?: string;
  required?: boolean;
  autoFocus?: boolean;
  hideValue?: boolean;
}

const BasicAutoComplete: React.FC<BasicAutoCompletePropTypes> = (props) => {
  const {
    options,
    setState,
    stateKey,
    secondaryStateKey,
    clear,
    label,
    required,
    autoFocus,
    hideValue,
  } = props;
  const [inputState, setInputState] = useState<any>();
  const [searchedOptions, setSearchedOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const formStyles = useFormStyles();

  useEffect(() => {
    setState((prev: any) => {
      return {
        ...prev,
        [stateKey]: inputState?.id,
        [secondaryStateKey]: inputState?.id,
      };
    });
  }, [inputState]);

  const generateOptions = (list: string[]) => {
    return list.map((list: any, index: number) => {
      return {
        id: list.id,
        label: list.label,
      };
    });
  };

  const handleKeyUp = async (e: React.SyntheticEvent) => {
    const query = (e.target as HTMLInputElement).value;
    deb(query);
  };

  const deb = debounce(async (query: any) => {
    setLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `/member/search?query=${query}`
      );
      const searchList = response?.data?.value?.map((data: any) => {
        return {
          id: data.userId,
          label: data.label,
          // label: isNaN(query) ? data.label : `${data.label} - ${query}`,
        };
      });
      setSearchedOptions(generateOptions(searchList));
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  }, 800);

  return (
    <Box>
      <FormLabel
        sx={{
          ...formStyles.formLabel,
          textAlign: "left",
        }}
      >
        {label}
      </FormLabel>
      <Autocomplete
        key={clear ? "autoCompleteReset" : "autoComplete"}
        onChange={(e: any, newValue: string | null) => {
          setInputState(newValue ?? "");
        }}
        onKeyUp={handleKeyUp}
        disableClearable={true}
        size="small"
        id="combo-box-demo"
        options={searchedOptions ? searchedOptions : options}
        loading={loading}
        disablePortal
        freeSolo
        renderInput={(params) => (
          <TextField
            sx={{
              position: "relative",
              background: theme.color?.background,
              border: `2px solid ${theme.color?.secondary}`,
              borderRadius: 2,
              outline: "none",
            }}
            type={hideValue ? "hidden" : "text"}
            autoFocus={autoFocus ? true : false}
            placeholder="Search by Email / Mobile"
            {...params}
            required={required ?? false}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress
                      size={20}
                      sx={{
                        position: "absolute",
                        right: 10,
                        top: "25%",
                        transform: "translateY(-50%)",
                        color: theme.color?.secondary,
                      }}
                    />
                  ) : (
                    <SearchIcon sx={{ color: theme.color?.secondary }} />
                  )}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default BasicAutoComplete;
